module.exports = "pegasus_template/assets/logo-preview.png";